import {
  convertTitleReportDataToTitleReportResponse,
  convertTitleReportResponseToTitleReportData,
  ITitleReportData,
  ITitleReportResponse,
} from '../../ui-toolkit/orders/interfaces/titleReport/ITitleReport';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler, axiosErrorHandlerExpects } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const finalizeAsync = async (orderId: string): Promise<any> => {
  return APIFactory(baseUrlService.ApiLocation)
    .patch(`/timber/api/internal/title/v1/${orderId}/finalize`)
    .catch(axiosErrorHandler);
};

export const getTitleReportAsync = async (orderId: string): Promise<ITitleReportData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<ITitleReportData>(`/timber/api/internal/title/v1/orders/${orderId}/search-report-form`)
    .then((response) => response.data)
    .catch(axiosErrorHandlerExpects([404]));

export const getTitleReportAndCreateAsync = async (orderId: string): Promise<ITitleReportData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<ITitleReportResponse>(`/title_reports/v1/internal/${orderId}`)
    .then((response) => convertTitleReportResponseToTitleReportData(response.data))
    .catch(axiosErrorHandler);

export const saveTitleReportAsync = async (orderId: string, payload: ITitleReportData): Promise<any> => {
  return APIFactory(baseUrlService.ApiLocation)
    .post<ITitleReportResponse>(
      `/title_reports/v1/internal/${orderId}`,
      convertTitleReportDataToTitleReportResponse(payload)
    )
    .catch(axiosErrorHandler);
};

export const deleteItemAsync = async (itemType: string, itemId: string): Promise<any> => {
  return APIFactory(baseUrlService.ApiLocation)
    .delete(`/timber/api/internal/title/v1/${itemType}/${itemId}`)
    .catch(axiosErrorHandler);
};
